import { ErrorBase } from '@/errors/ErrorBase';

export class UserNotFoundError extends ErrorBase {
    static get defaultMessage(): string {
        return 'ユーザーが見つかりませんでした。';
    }

    static get errorName(): string {
        return 'UserNotFoundError';
    }
}
